// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"_3e355497"};